import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from '../../services/api';

const name = 'updateFeedbackOption';
const initialState = createInitialState();

function createInitialState() {
    return {
        done: false,
        error: false,
        spinner: false,
        updateFeedbackOption: null,
    };
}

    
export const updateFeedbackOption = createAsyncThunk('updateFeedbackOption', async ({ id, value}, { rejectWithValue }) => {
    try {
        const response = await api.put('/super/api/feedback/option/update', { id, value });
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response.data);
    }
});

const updateFeedbackOptionSlice = createSlice({
    name: name,
    initialState,
    reducers: {
        resetUpdateFeedbackOption: state => {
            state.done = false;
            state.error = false;
            state.spinner = false;
            state.updateFeedbackOption = null;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(updateFeedbackOption.pending, state => {
                state.spinner = true;
                state.error = false;
            })
            .addCase(updateFeedbackOption.fulfilled, (state, action) => {
                state.done = true;
                state.spinner = false;
                state.error = false;
                state.updateFeedbackOption = action.payload;
            })
            .addCase(updateFeedbackOption.rejected, (state, action) => {
                state.done = false;
                state.spinner = false;
                state.error = action.payload;
            });
    },
});

export const { resetUpdateFeedbackOption } = updateFeedbackOptionSlice.actions;
export const updateFeedbackOptionReducer = updateFeedbackOptionSlice.reducer;
